import { Component } from '@angular/core';
import { RouteService } from '../../../services/route.service';

@Component({
    selector: 'app-offline-message',
    templateUrl: './offline-message.component.html',
    styleUrls: ['./offline-message.component.scss'],
    standalone: true
})
export class OfflineMessageComponent {

    constructor(public routeService: RouteService) {
    }
}
